var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBimAm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BIM"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97 37 66 22 35 37 35 89 66 105 97 89 97 37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97 37 66 53 35 37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66,
    y1: 105,
    x2: 66,
    y2: 53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "27 49 12 56 66 82.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "105 49 120 56 66 82.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "44.13 93.71 44 80 52 84 52 98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBimAm);
export default __webpack_public_path__ + "static/media/bim_am.610445c64d11e46a73a704ce2e7d6470.svg";
export { ForwardRef as ReactComponent };